import { render, staticRenderFns } from "./InteractiveWall.vue?vue&type=template&id=a99d74d0&scoped=true&"
import script from "./InteractiveWall.vue?vue&type=script&lang=js&"
export * from "./InteractiveWall.vue?vue&type=script&lang=js&"
import style0 from "./InteractiveWall.vue?vue&type=style&index=0&id=a99d74d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99d74d0",
  null
  
)

export default component.exports